import Immutable from 'immutable'

export function addonsFromIds(addons, addonIds, booking){
  const fullAddons = addonIds.map((id) => addons.find((addon) => addon.get('id') === id))
  return addMissingAddons(fullAddons, booking)
}

export function complimentaryAddons(bookingType) {
  return ['move_in', 'move_out'].indexOf(bookingType) > -1
}

// If a booking has an addon that is not included in the list of addons that is live currently
export function addMissingAddons(liveAddons, booking) {
  if(!booking || !booking.addons) {
    return liveAddons;
  }

  return liveAddons.concat(booking.addons.filter((addon) => {
    return !liveAddons.find((a) => a.get('id') == addon.id)
  }).map ((a) => Immutable.fromJS(a)))
}
